// SelectedShorting.tsx
import {
  DeleteIcon,
  DropdownIcon,
  SortingFilterIcon,
} from "app/components/Icons";
import SortIcon from "app/components/Icons/SortIcon";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "app/components/Popover";
import clsx from "clsx";
import React from "react";
import SelectedShortingRow from "./SelectedShortingRow";
import { buildOptionsForRow, getLabelForKey } from "./sortingHelpers";
import { SelectedSortingProps } from "./types";


const SelectedShorting: React.FC<SelectedSortingProps> = ({
  fields,
  rules,
  draggedIndex,
  onRemoveRule,
  onUpdateField,
  onUpdateOrder,
  onReorder,
  onClearRules,
  onUpdateDraggedIndex,
}) => {
  const [open, setOpen] = React.useState(false);

  const filledRules = rules.filter((r) => r.fieldKey !== null);

  const handleDrop = (index: number) => {
    if (draggedIndex !== null) {
      onReorder(draggedIndex, index);
      onUpdateDraggedIndex(null);
    }
  };

  return (
    <div className="relative">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button className="border border-primary rounded-full bg-white text-primary text-sm font-medium flex items-center justify-between h-8 px-1 gap-1 min-w-max">
            {filledRules.length > 1 ? (
              <div className="flex gap-1 items-center justify-center">
                <SortingFilterIcon color="#5A8DF1" size={20} />
                <span>{filledRules.length} sorts</span>
              </div>
            ) : (
              <div className="flex gap-1 items-center justify-center">
                <SortIcon color="#5A8DF1" />
                <span>
                  {filledRules.length}{" "}
                  {getLabelForKey(filledRules[0]?.fieldKey ?? null, fields)}
                </span>
              </div>
            )}
            <div
              className={clsx(
                "size-[16px] min-w-[16px] transition-transform duration-300 ease-in-out",
                open ? "rotate-180" : "",
              )}
            >
              <DropdownIcon color="#5A8DF1" size={20} />
            </div>
          </button>
        </PopoverTrigger>

        <PopoverContent
          align="start"
          className="w-full bg-white border border-[#E9ECF2] !px-0 !py-2"
        >
          {rules.map((r, i) => (
            <SelectedShortingRow
              key={i}
              index={i}
              rule={r}
              fieldOptions={buildOptionsForRow(rules, fields, i)}
              onDragStart={onUpdateDraggedIndex}
              onDragOver={(e) => e.preventDefault()}
              onDrop={handleDrop}
              onUpdateField={onUpdateField}
              onUpdateOrder={onUpdateOrder}
              onRemove={onRemoveRule}
            />
          ))}

          <div className="px-4 py-3 flex items-center gap-1.5 hover:bg-gray-400">
            <button
              onClick={onClearRules}
              className="flex items-center gap-2 text-sm text-secondary"
            >
              <DeleteIcon color="#79808A" />
              Delete sort
            </button>
          </div>
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default SelectedShorting;
